// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterSection_container__cGy5F","titleContainer":"FilterSection_titleContainer__gERPM"};